import React from 'react';

interface RectangleIconProps {
  className?: string;
  size?: number;
}

export const RectangleIcon: React.FC<RectangleIconProps> = ({ 
  className = "w-5 h-5", 
  size = 20 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Rectangle with slightly rounded corners */}
      <rect
        x="4"
        y="6"
        width="16"
        height="12"
        rx="1"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Subtle inner detail */}
      <rect
        x="6"
        y="8"
        width="12"
        height="8"
        rx="0.5"
        stroke="currentColor"
        strokeWidth="0.5"
        fill="none"
        opacity="0.4"
      />
      {/* Corner accent */}
      <path
        d="M4 6h2v2"
        stroke="currentColor"
        strokeWidth="1"
        opacity="0.6"
      />
    </svg>
  );
};

export default RectangleIcon;
